export default __webpack_public_path__ + "static/media/aretha-modal.f41157fb.jpg";